import React from 'react';
import { useNavigate } from 'react-router-dom';

const UpgradeScreen = ({ feature }) => {
    const navigate = useNavigate();

    const getMessage = () => {
        switch (feature) {
            case 'TSG_NOTES':
                return "TSG Notes is available only for premium subscribers.";
            case 'BOOTCAMP':
                return "BootCamp access is available only for subscribed users.";
            case 'MOCK_INTERVIEW':
                return "Upgrade to SkillGenie Premium to unlock unlimited Mock Interviews and specialized tracks.";
            case 'TSG_AI':
                return "TSG AI is available only for 3 and 6 month premium plans.";
            default:
                return "Upgrade your subscription to continue learning without limits.";
        }
    };

    return (
        <div className="flex flex-col items-center justify-center p-8 bg-[#1E1B4B] border border-primary/30 rounded-2xl shadow-2xl text-center max-w-2xl mx-auto my-10 overflow-hidden relative">
            {/* Background Decorative Element */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-primary/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-accent/20 rounded-full blur-3xl"></div>

            <div className="w-20 h-20 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 border border-primary/20 relative z-10">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
            </div>
            
            <h2 className="text-3xl font-bold text-white mb-4 relative z-10">Unlock Premium Features</h2>
            <p className="text-gray-300 text-lg mb-8 relative z-10">
                {getMessage()}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 w-full justify-center relative z-10">
                <button 
                    onClick={() => navigate('/subscription-plans')}
                    className="px-8 py-3 bg-gradient-to-r from-primary to-accent hover:from-secondary hover:to-primary text-white font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-primary/25"
                >
                    View Plans
                </button>
                <button 
                    onClick={() => navigate('/subscription-plans')}
                    className="px-8 py-3 border border-primary/50 text-white hover:bg-primary/10 font-bold rounded-xl transition-all"
                >
                    Upgrade Now
                </button>
            </div>
        </div>
    );
};

export default UpgradeScreen;
